import ResourceDetailContent from '../components/ResourceDetail/ResourceDetailContent';

const ResourceDetailPage = () => {
  return <ResourceDetailContent />;
};

export default ResourceDetailPage;